import React from 'react';
import { AreaChart, Area, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import { vendorScoreService } from '@/services/vendorScoreService';
import { cleanDateAndTimeObject } from '../../shared/renderDate';
import { useTheme } from '@/contexts/ThemeContext';
import { colorValues } from '@/contexts/ThemeContext';

interface MiniVendorScoreChartProps {
  vendorWebsite: string;
}

export const MiniVendorScoreChart: React.FC<MiniVendorScoreChartProps> = ({ vendorWebsite }) => {
  const [history, setHistory] = React.useState<any[]>([]);
  const theme = useTheme();
  const primaryColor = colorValues[theme.primaryColor]?.[theme.isDark ? 'dark' : 'light']?.primary || '#2563eb';

  React.useEffect(() => {
    if (!vendorWebsite) return;

    const fetchHistory = async () => {
      try {
        const data = await vendorScoreService.getVendorScoreHistory(vendorWebsite, 20); // Limit to 20 for mini chart
        const chartData = data
          .map(item => ({
            date: cleanDateAndTimeObject(item.captureDate),
            score: item.capturedScore,
          }))
          .filter(item => item.date && item.score !== undefined)
          .sort((a, b) => a.date!.getTime() - b.date!.getTime())
          .map((item, index) => ({
            x: index,
            score: item.score,
          }));
        setHistory(chartData);
      } catch (error) {
        console.error('Failed to fetch mini chart history:', error);
        setHistory([]);
      }
    };

    fetchHistory();
  }, [vendorWebsite]);

  if (!history.length) {
    return <span className="text-muted-foreground text-xs">No data</span>;
  }

  return (
    <ResponsiveContainer width={80} height={30}>
      <AreaChart data={history}>
        <XAxis dataKey="x" hide />
        <YAxis hide domain={[0, 1000]} />
        <Area
          type="monotone"
          dataKey="score"
          stroke={primaryColor}
          strokeWidth={2}
          fill={primaryColor}
          fillOpacity={0.2}
          dot={{ fill: primaryColor, strokeWidth: 1, r: 1 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};
